const API_ROOT = process.env.VUE_APP_API_ROOT ?? '/api';
const APP_BASE_URL = process.env.VUE_APP_BASE_URL ?? '/';
const NODE_ENV = process.env.NODE_ENV;

export {
    API_ROOT,
    APP_BASE_URL,
    NODE_ENV
};